const drawerWidth = 200;

export default (theme) => ({
    appBar: {
        position: 'absolute',
        zIndex: 1001,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButtonIcons: {
        left: -1
    },
    menuButton: {
        left: -25
    },
    hide: {
        display: 'none',
    },
    drawerPaperDocked: {
        height: '100%',
    },
    drawerPaper: {
        position: 'relative',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
        height: '100%',
        zIndex: 1000
    },
    drawerPaperClose: {
        width: 50,
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        '&:hover': {
            width: drawerWidth,
        },
        [theme.breakpoints.down('sm')]: {
            width: 0,
        },
    },
    drawerInner: {
        // Make the items inside not wrap when transitioning:
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    content: {
        width: '100%',
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: 24,
        height: 'calc(100% - 56px)',
        marginTop: 56,
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100% - 64px)',
            marginTop: 64,
        },
    },
    topBarUserName: {
        position: 'absolute',
        right: 20,
    },
    topBarUserNameInfo: {
        color: '#b5ccc6',
        float: 'right',
        [theme.breakpoints.up('xs')]: {
            fontSize: '12px'
        },
    },
    topBarUserNameText: {
        color: '#fff',
        fontWeight: '500',
        float: 'right',
        [theme.breakpoints.up('xs')]: {
            fontSize: '12px'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '16px'
        },
    },
    textImageUploading: {
        marginTop: '-19px',
        textAlign: 'center',
        position: 'relative',
        color: '#fff',
        fontWeight: 500,
        zIndex: 2,
    },
    paperImageUploading: {
        height: 20,
        position: 'fixed',
        width: '100%',
        top: 57,
        [theme.breakpoints.up('sm')]: {
            top: 65,
        },
    }
});



// WEBPACK FOOTER //
// ./src/containers/layout/style/side_menu.js